import { createComponent } from '@ycos/fela'
import { getFontStyles } from '../'

const Prefix = createComponent(
  'Prefix',
  ({ textAlign, inverseColor, theme }) => {
    const {
      typography,
      custom: { prefix },
      spacingMultiplier
    } = theme

    return {
      ...getFontStyles(typography, { type: prefix.type, name: prefix.name }),
      color: inverseColor ? prefix.inverseColor : prefix.color,
      margin: `0 0 ${spacingMultiplier}px`,
      textAlign,
      direction: 'ltr'
    }
  },
  'div'
)

export default Prefix
